import { FC } from 'react';
import { Pax } from 'ts/hotel/interfaces/BookResponse';
import { dateFormat } from 'utils/shared/utils';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { PaxHotelType } from 'ts/hotel/classes/BookModel';
import { useTranslation } from 'react-i18next';
import { addYears } from 'date-fns';
import { b2b } from 'constants/generic';

interface PassengerTableProps {
  paxes: Pax[];
}

const PassengerTable: FC<PassengerTableProps> = ({ paxes }) => {
  const { t } = useTranslation();
  const getTitle = (pax: Pax) => {
    const dob = new Date(pax.dob);
    if (addYears(dob, 2) > new Date()) {
      return t('search.infant');
    }

    if (pax.paxTypeCode === PaxHotelType.CHILD) {
      return t('child');
    }
    return t(b2b ? `passenger.${pax.title}` : pax.gender);
  };

  return (
    <div className="book-preview-table mb-20">
      <table>
        <thead>
          <tr>
            <th> {t(b2b ? 'passenger.title' : 'passenger.gender')}</th>
            <th>{t('passenger.ln')}</th>
            <th>{t('passenger.fn')}</th>
            <th>{t('passenger.dob')}</th>
            <th>{t('passenger.email')}</th>
            <th>{t('passenger.phone')}</th>
          </tr>
        </thead>
        <tbody>
          {paxes.map((pax: Pax) => (
            <tr key={pax.paxCode}>
              <td>{getTitle(pax)}</td>
              <td>{pax.lastName}</td>
              <td>{pax.firstName}</td>
              <td>
                {pax.paxTypeCode === PaxHotelType.CHILD &&
                  dateFormat(new Date(pax.dob), 'yyyy-MM-dd')}
              </td>
              <td>{pax.email}</td>
              <td dir="ltr">{pax.phone}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default withErrorBoundary(PassengerTable, 'PassengerTable');
